import get from 'lodash.get';
import { trackEcommerce, trackEvent, trackingConstants, eventNameConstants } from 'dibs-tracking';
import {
    getIsFreeShipping,
    getLowestEligibleShippingCost,
} from 'dibs-search-product-tile/exports/shippingCostHelpers';

const MAX_IMPRESSION_GROUP_COUNT = 20;

const { ECOM_PRODUCT_CLICK, ECOM_PRODUCT_IMPRESSION } = trackingConstants;
const { EVENT_SELECT_ITEM, EVENT_VIEW_ITEM_LIST } = eventNameConstants;

const getImpressionGroups = nodes =>
    nodes.reduce((groups, { node }, index) => {
        const group = Math.floor(index / MAX_IMPRESSION_GROUP_COUNT);
        if (!groups[group]) {
            groups[group] = {
                tracked: false,
                items: [],
            };
        }
        groups[group].items.push(node.item);
        return groups;
    }, {});

const trackRelatedItems = ({
    items = [],
    type,
    searchTerm,
    startIndex,
    userRegions,
    eventName,
}) => {
    const actionField = { list: 'null results - related items' };

    if (eventName === EVENT_SELECT_ITEM) {
        actionField.itemId = items?.[0]?.serviceId;
    }

    trackEcommerce({
        type,
        eventName,
        actionField,
        products: items.map((item, index) => {
            const isFreeShipping = getIsFreeShipping({ item, userRegions });
            const lowestEligibleShippingCost = getLowestEligibleShippingCost({ item, userRegions });
            return {
                brand: get(item, 'seller.serviceId'),
                category: item.browseUrl,
                categoryCode: item.categoryCode,
                id: item.serviceId,
                name: item.title,
                list: 'null results - related items',
                dimension83: item.contemporaryTrackingString,
                dimension98: searchTerm,
                dimension106: isFreeShipping ? 'Y' : 'N',
                dimension120: lowestEligibleShippingCost,
                position: startIndex + index + 1,
                url: item.link || '',
            };
        }),
    });
};

export const trackNullSearchRelatedItemProvider = ({ nodes = [], searchTerm, userRegions }) => {
    const impressionGroups = getImpressionGroups(nodes);

    return {
        trackNullSearchRelatedItemsLoad: () => {
            if (nodes.length && searchTerm) {
                trackEvent({
                    label: searchTerm,
                    category: 'product list',
                    action: 'null results related items',
                });
            }
        },
        trackNullSearchRelatedItemClick: ({ item, index }) => {
            trackRelatedItems({
                searchTerm,
                items: [item],
                type: ECOM_PRODUCT_CLICK,
                startIndex: index + 1,
                userRegions,
                eventName: EVENT_SELECT_ITEM,
            });
        },
        trackNullSearchRelatedItemsImpressions: ({ index }) => {
            const group = Math.floor(index / MAX_IMPRESSION_GROUP_COUNT);
            const { tracked, items: groupItems } = impressionGroups[group];
            if (!tracked) {
                trackRelatedItems({
                    searchTerm,
                    items: groupItems,
                    startIndex: group * MAX_IMPRESSION_GROUP_COUNT,
                    type: ECOM_PRODUCT_IMPRESSION,
                    userRegions,
                    eventName: EVENT_VIEW_ITEM_LIST,
                });
                impressionGroups[group].tracked = true;
            }
        },
    };
};
